/**
 * GIGAPOD 연동 공용 상수.
 *
 * 로고는 lucide 컴포넌트 아이콘이 아니라 public 자산(브랜드 이미지)이라
 * 관리자 사이드바 / 설정 페이지 / 좌측 모듈 레일 세 곳이 같은 경로를 공유한다.
 */
export const GIGAPOD_ICON_SRC = '/assets/icon/GIGAPOD.webp';

/** 브랜드명 — 로케일 무관 고정 표기이므로 번역 대상이 아니다. */
export const GIGAPOD_LABEL = 'GIGAPOD';
